
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'
import VueAnalytics from 'vue-analytics'
import "firebase/analytics"
import AOS from 'aos'
import 'aos/dist/aos.css'
import LogRocket from 'logrocket';
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

LogRocket.init('2zl1iy/panneau-mobile');
Vue.use(firestorePlugin)

Vue.config.productionTip = false;
Vue.use(Argon);

Vue.use(VueAnalytics, {
  id: '274080597', router
});

const firebaseConfig = {
  apiKey: "AIzaSyA3DNMcrN6v-yu-lzrL7d-v45VyOL0v-SI",
  authDomain: "pmobile-bj.firebaseapp.com",
  projectId: "pmobile-bj",
  storageBucket: "pmobile-bj.firebasestorage.app",
  messagingSenderId: "236860363554",
  appId: "1:236860363554:web:7bfb3035d0de0e77fd4b7b",
  measurementId: "G-YCDLNXYS61"
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

firebase.analytics();

export const db = firebase.firestore()

new Vue({
  router,
  render: h => h(App),
  mounted () {
    AOS.init()
  }
}).$mount("#app");
